// KetoNoir — Shopify Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // Fade-in on scroll
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));

  // Variant selector → update price + ATC button
  const variantSelects = document.querySelectorAll('.variant-select');
  variantSelects.forEach(sel => {
    sel.addEventListener('change', updateVariant);
  });

  function updateVariant() {
    const options = [];
    document.querySelectorAll('.variant-select').forEach(s => options.push(s.value));
    // Shopify will handle variant ID update via page reload or AJAX
  }

});
